export default __webpack_public_path__ + "static/media/logout_icon_bold.aa811cdb.svg";